export enum AssignationType {
    GROUP = "group",
    INDIVIDUAL = "individual",
    NONE = "without-assignation",
}

export default AssignationType;
